import { useSelector } from "react-redux";
import { IRootReducerState } from "../redux-store/rootReducer";
import { ensureState, OptimisticState } from "redux-optimistic-ui";

export const useSelect = <TSelected>(
  selector: (
    state: IRootReducerState
  ) => OptimisticState<TSelected> | TSelected,
  equalityFn?: (left: TSelected, right: TSelected) => boolean
) =>
  ensureState(
    useSelector<IRootReducerState, OptimisticState<TSelected> | TSelected>(
      selector,
      equalityFn as any
    )
  );
